import { config } from '../../config';
import { useAuth } from '@presov.sk/presov-auth-react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

const RecaptchaWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { authState } = useAuth();
  if (authState !== 'unauthorized') {
    // Ak nie je user prihlaseny, recaptcha neriesime
    return <>{children}</>;
  }

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={config.RECAPTCHA_KEY}
      language='sk'
      scriptProps={{
        async: false, // optional, default to false,
        defer: false, // optional, default to false
        appendTo: 'head', // optional, default to "head", can be "head" or "body",
        nonce: undefined, // optional, default undefined
      }}
    >
      {children}
    </GoogleReCaptchaProvider>
  );
};

export default RecaptchaWrapper;
